const AppName = "Redlake Kids Zone";
const Language = "Ojibwe";
const Tribe = "Ojibwe";
const FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_REDLAKE,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_REDLAKE,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_REDLAKE,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_REDLAKE,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_REDLAKE,
  appId: process.env.REACT_APP_FIREBASE_APP_ID_REDLAKE,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_REDLAKE,
};
const FilePath = "https://storage.googleapis.com/redlake-media/";
const NacaApiUrl = process.env.REACT_APP_NACA_API_URL || "https://naca.community";
const NacaCommunityId = "a83a3525-4dd8-4179-9046-c6456b5b8d68";

const SheetsToPull = [
  { collection: "KZ_AppData", nameToSave: "vocabData" },
  { collection: "KZ_GameFilterDataNew", nameToSave: "gameData" },
  { collection: "KZ_uiWords", nameToSave: "uiWords" },
  { collection: "KZ_GameDescriptions", nameToSave: "gameDescriptions" },
  { collection: "KZ_PopupWords", nameToSave: "popupWords" },
];

const ParamsToFindGame = [
  { data: "category", param: "unit" },
  { data: "target", param: "game-name" },
  { data: "Key", param: "Key" },
];

const NumberDataCategory = "0 to 20";

const FeedbackLink = "https://forms.gle/NJd1pfbuV8Dv3nrs8";

const BottomColor = "rgba(134,45,116,1)";

const VersionNumber = "2.02.00057";

const Credits = {
  credits: [
    "Website created and designed through Native Teaching Aids LLC by Thomas Koefod and Spencer Kittle",
  ],
  links: [
    {
      link: "https://www.nativeteachingaids.com",
      image: "ntalogo.png",
      style: "short",
    },
  ],
};

const PossibleGames = [
  "Bubble Pop",
  "Counting",
  "Good Guess",
  "Matching",
  "Verb Activity",
  "Whack-A-Mole",
  "Word To Image",
  "Wordless",
  "From Me To You",
];

const config = {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  FeedbackLink,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
};

export default config;

export {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  FeedbackLink,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
};
